export default __webpack_public_path__ + "static/media/05AW1JUL66.cc601b9c.jpg";